<template>
    <div class="input-group">

        <input v-model="text" type="text" :name="name" class="form-control" :id="id" :placeholder="placeholder">

        <div class="input-group-append" >
            <span class="input-group-text" :class="cssObject">
                {{ length }} / {{ maxLength}}
            </span>
        </div>
    </div>

    
</template>

<script>
  import MetaInfo from './MetaInfo';

  export default {
    name: "meta-title",
    mixins: [MetaInfo],
    props: {
      id: {
        required: false,
        default: 'meta-title-input',
      },
      name: {
        required: false,
        default: 'meta_title',
      },
      maxLength: {
        required: false,
        type: Number,
        default: 60,
      },
    }
  }
</script>

<style scoped>

</style>